@if (option.familyAllowed && form.get('childrenEnabled')?.value) {
@for (child of childrenArray.controls; let i = $index; track i) {
<div [formGroup]="child" class="row py-3 border-top align-items-end">
  <div class="col-12 col-md-4">
    <label [for]="'insuranceItemBirthDateChild' + i"
      class="form-label small fw-semibold text-muted text-uppercase uppercase">Fecha de nacimiento del
      hijo/a</label>
    <app-datepicker-input [id]="'insuranceItemBirthDateChild' + i" formControlName="birthDate"
      [control]="child.get('birthDate')" inputClass="form-control py-2 focus-ring fw-bold focus-ring-success"
      [errorMessages]="{
                              required: 'La fecha de nacimiento del hijo/a es obligatoria',
                              invalidBirthDate: 'Fecha no válida',
                              minAge: 'El hijo/a debe tener al menos ' + (option.childMinAge ?? option.minAge) + ' años',
                              maxAge: 'El hijo/a debe tener como máximo ' + (option.childMaxAge ?? option.maxAge) + ' años',
                              minParentAgeDiff: 'La diferencia de edad con el asegurado principal no puede ser menor a 13 años',
                              minSpouseAgeDiff: 'La diferencia de edad con el cónyuge no puede ser menor a 13 años'
                            }"></app-datepicker-input>
  </div>
  <div class="col">
    <div class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Sexo de Hijo/a
    </div>
    <div class="d-flex gap-2">
      <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
        <input [id]="'insuranceSexchildren' + i + '1'" [value]="Gender.F"
          class="form-check-input focus-ring focus-ring-success" formControlName="gender" type="radio">
        <label [for]="'insuranceSexchildren' + i + '1'" class="form-check-label fw-bold">Femenino</label>
      </div>
      <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
        <input [id]="'insuranceSexchildren' + i + '2'" [value]="Gender.M"
          class="form-check-input focus-ring focus-ring-success" formControlName="gender" type="radio">
        <label [for]="'insuranceSexchildren' + i + '2'" class="form-check-label fw-bold">Masculino</label>
      </div>
    </div>
    @if (child.get('gender')?.touched && child.get('gender')?.hasError('required')) {
    <div class="text-danger small mt-1">Debe seleccionar el sexo del hijo/a.</div>
    }
  </div>
  <div class="col-auto">
    <div class="d-flex py-1 gap-2">
      <button (click)="removeChild(i)" class="btn btn-outline-danger border-2 btn-sm rounded-3" type="button">
        <app-icon [size]="24" [strokeWidth]="2" name="user-minus"></app-icon>
      </button>
    </div>
  </div>
</div>
}
<div class="row g-3 mt-2 mb-3">
  <div class="col-12">
    <button (click)="addChild()" class="btn fw-semibold btn-outline-success border-2 btn-sm rounded-3" type="button">
      <app-icon [size]="24" [strokeWidth]="2" name="user-plus"></app-icon>
      Agregar hijo
    </button>
  </div>
</div>
}